import React, { FC } from 'react';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';

import { useTimesheetData, useTimesheetEdit } from 'src/features/timesheets/providers';
import { CheckIcon, SaveIcon, UndoIcon } from 'src/shared/components';
import { PermissionsEnums } from 'src/shared/enums';
import { ComponentWithPermissions } from 'src/shared/hocs';
import { useTranslate } from 'src/shared/providers';

export const TimesheetFooter: FC = () => {
  const { t } = useTranslate();

  const { isSubmitEnabled } = useTimesheetData();
  const { onSave, onCancel, onSubmit, isEdited, loading } = useTimesheetEdit();

  return (
    <ComponentWithPermissions permissions={PermissionsEnums.SHIFTMATCH_EDIT}>
      <Stack direction="row" justifyContent="flex-end" alignItems="center" gap={1}>
        <Button variant="text" startIcon={<UndoIcon />} onClick={onCancel} disabled={!isEdited || loading}>
          {t('global.cancel')}
        </Button>
        <ComponentWithPermissions permissions={PermissionsEnums.WTS_SUBMIT_TO_SUP}>
          <Button
            color="secondary"
            startIcon={<CheckIcon />}
            onClick={onSubmit}
            disabled={isEdited || !isSubmitEnabled || loading}
          >
            {t('timesheets.submitToSupervisor')}
          </Button>
        </ComponentWithPermissions>
        <Button variant="contained" startIcon={<SaveIcon />} onClick={onSave} disabled={!isEdited || loading}>
          {t('global.save')}
        </Button>
      </Stack>
    </ComponentWithPermissions>
  );
};
